import React from 'react';
import "./Button.scss";

const Button = (props) => {
    return (
        <div className="btn-main-container">
            <button type="button" class="btn btn-primary" onClick={()=>props?.onClick()}>{props?.name}</button>
        </div>
    );
};

export default Button;